import { Stack } from "@mui/material";
import { LassoFormField } from "../../../components/form/LassoFormField";


const SubRecipientInfoComponent = ({ id, control, disabled, errors }: any) => {


    return (
        <Stack direction="column" gap={4}>
            <Stack direction="row" gap={4} sx={{ flexDirection: { xs: "column", md: "row" } }}>
                <LassoFormField
                    id={`duc-subrecipients-firstName-${id + 1}`}
                    label="First Name"
                    required
                    disabled={disabled}
                    controller={{
                        name: `subApplicants.${id}.firstName`,
                        control: control,
                        rules: { required: "This field is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" } }
                    }}
                    fullWidth
                    error={!!errors?.[id]?.firstName}
                    helperText={errors?.[id]?.firstName?.message}
                />
                <LassoFormField
                    id={`duc-subrecipients-lastName-${id + 1}`}
                    label="Last Name"
                    required
                    disabled={disabled}
                    controller={{
                        name: `subApplicants.${id}.lastName`,
                        control: control,
                        rules: { required: "This field is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" } },
                    }}
                    fullWidth
                    error={!!errors?.[id]?.lastName}
                    helperText={errors?.[id]?.lastName?.message}
                />
            </Stack>



            <LassoFormField
                id={`duc-subrecipients-email-${id + 1}`}
                label="Email"
                disabled={disabled}
                required
                controller={{
                    name: `subApplicants.${id}.email`,
                    control: control,
                    rules: {
                        required: "This field is required", pattern: {
                            value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: 'Invalid email address',
                        },
                    }
                }}
                fullWidth
                error={!!errors?.[id]?.email}
                helperText={errors?.[id]?.email?.message}
            />

        </Stack>

    )
}

export default SubRecipientInfoComponent;